export const ServiceDataKeys = {
  SPRING_MODAL: 'springModal24May2026',
};
